import { ServicesProperty } from '@onlog-public/additional-services-types';
import { AdditionServicesOptionsState } from '@pages/AdditionalServices/containers/additionServicesOptionsContext';
import { SelectOption } from '@pages/AdditionalServices/containers/services/optionsGenerator/types';
import propertyOptionsGenerator from '@pages/AdditionalServices/containers/services/propertyOptionsGenerator';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';

import { ServiceData, SetUpServiceData } from '../../../basket/types';
import { serviceRestoreStateGeneratorProcessor } from '../types';

/**
 * ServicePropertyCacheOptionsProcessor формирует кэш данных для значений опций услуг
 */
export class ServicePropertyCacheOptionsProcessor implements serviceRestoreStateGeneratorProcessor {
  /**
   * restore выполняет восстановление стейтов. Возвращает все стейты.
   * @param _
   * @param __
   * @param additionalServiceState
   * @param optionsState
   * @param serviceCacheState
   * @param servicePropertyCacheState
   * @param servicePropertyFilterAndOrderState
   */
  async restore(
    _: SetUpServiceData,
    __: (SetUpServiceData | ServiceData)[],
    additionalServiceState: AdditionServicesState,
    optionsState: AdditionServicesOptionsState,
    serviceCacheState: AServiceCache,
    servicePropertyCacheState: AServicePropertyCache,
    servicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder
  ) {
    const state = { ...servicePropertyCacheState };

    const allProperties: { [T in string]: ServicesProperty } = {};
    const props = [
      ...additionalServiceState.PropertiesToDisplay,
      ...Object.values(additionalServiceState.VariantProperties).flat(1),
    ];
    props.map((p) => (allProperties[p.id] = p));

    const options: { [T in string]: { [K in string]: SelectOption[] } } = {};
    Object.keys(additionalServiceState.PropertyValues).map((variantID) => {
      options[variantID] = {};
      Object.keys(additionalServiceState.PropertyValues[variantID]).map((propertyID) => {
        const property = allProperties[propertyID];
        if (!property) {
          return;
        }

        if (['switch', 'number', 'hidden'].includes(property.type)) {
          return;
        }

        const values = additionalServiceState.PropertyValues[variantID][propertyID];
        options[variantID][propertyID] = propertyOptionsGenerator().getOptions(
          property.type,
          state.LangID,
          String(property.handbook_id),
          values.map((v) => String(v)),
          state.Cache[property.type]
        );
      });
    });

    return {
      isValid: true,
      additionalServiceState,
      optionsState,
      serviceCacheState,
      servicePropertyCacheState: {
        ...state,
        Options: options,
      },
      servicePropertyFilterAndOrderState,
    };
  }
}
